import React from "react";

const PanelManagementFlow = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Panel Management Workflow
      </h2>

      {/* Flow Diagram */}
      <div className="space-y-6">
        {/* Step 1: Project Creation */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">
              1
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Project Creation
            </h3>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <ul className="space-y-2 text-sm text-blue-800">
                <li>• Admin creates project and selects type</li>
                <li>• Types: Community, Joint Community (2/3), Independent</li>
                <li>• Admin adds REPS (representatives)</li>
                <li>• REPS can be community members or clients</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <svg
            className="w-6 h-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>

        {/* Step 2: Shortlisting */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-emerald-800 text-white rounded-full flex items-center justify-center font-bold">
              2
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Shortlisting Process
            </h3>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <ul className="space-y-2 text-sm text-green-800">
                <li>• Cadres declare conflict of interest</li>
                <li>• Those with no conflicts become shortlisted</li>
                <li>• Shortlisted cadres are "shortlist Cadres"</li>
                <li>• Only shortlisted cadres can be panelists</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <svg
            className="w-6 h-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>

        {/* Step 3: Adding Panelists */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center font-bold">
              3
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Adding Panelists
            </h3>
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
              <div className="space-y-3">
                <div>
                  <h4 className="font-medium text-purple-900 mb-2">
                    Selection Rules by Project Type:
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    <div className="bg-white p-3 rounded border">
                      <strong>Community:</strong> 1 client + 1 community
                    </div>
                    <div className="bg-white p-3 rounded border">
                      <strong>Joint Community (2):</strong> 1 client + 2
                      communities
                    </div>
                    <div className="bg-white p-3 rounded border">
                      <strong>Joint Community (3):</strong> 1 client + 3
                      communities
                    </div>
                    <div className="bg-white p-3 rounded border">
                      <strong>Independent:</strong> 1 client only
                    </div>
                  </div>
                </div>
                <div className="text-sm text-purple-800">
                  <p>• Community users select only community Cadres</p>
                  <p>• Clients select only client Cadres</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <svg
            className="w-6 h-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>

        {/* Step 4: Panel Display */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold">
              4
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Panel Display & Selection
            </h3>
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
              <ul className="space-y-2 text-sm text-orange-800">
                <li>
                  • <strong>Select Panelist</strong> option in panel
                </li>
                <li>
                  • New <strong>Panelist</strong> tab added to page
                </li>
                <li>• Users see only relevant Cadres (community/client)</li>
                <li>• Selection from shortlisted Cadres only</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <svg
            className="w-6 h-6 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>

        {/* Step 5: Viewing Details */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center font-bold">
              5
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Viewing Details
            </h3>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <ul className="space-y-2 text-sm text-red-800">
                <li>
                  • <strong>View Details</strong> for each project/test
                </li>
                <li>• Documents, timeline, and numbers displayed</li>
                <li>• Data derived from shortlisted Cadres only</li>
                <li>• User-specific data visibility (community/client)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* User Restrictions Summary */}
      <div className="mt-8 bg-gray-50 border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          User Restrictions & Data Visibility
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2">
              Community Users
            </h4>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• See only community-related data</li>
              <li>• Select only community Cadres</li>
              <li>• View community panelist details</li>
            </ul>
          </div>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-900 mb-2">Client Users</h4>
            <ul className="text-sm text-green-800 space-y-1">
              <li>• See only client-related data</li>
              <li>• Select only client Cadres</li>
              <li>• View client panelist details</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelManagementFlow;
